export const CONFIRMATION = (visibilityName: string) => `Are you sure you want to set ${visibilityName} for this merchant?`;

export const LIST_DESCRIPTION = 'Once the status is updated,';

export const BUTTONS = {
  CANCEL: 'Cancel',
};
